export default __webpack_public_path__ + "static/media/Profile.0c648be7.svg";